import CholeBhature from "../images/CholeBhature.jpg";
import KadhaiPaneer from "../images/Kadai-Paneer-2-3.jpg";
import PalakPaneer from "../images/Saag-Paneer-FF.jpg";

export const Data = [
  {
    name: "Chole Bhature",
    image: CholeBhature,
    price: 200,
  },

  {
    name: "Kadahi Paneer",
    image: KadhaiPaneer,
    price: 500,
  },

  {
    name: "Palak Paneer",
    image: PalakPaneer,
    price: 450,
  },
  {
    name: "Chole Bhature",
    image: CholeBhature,
    price: 200,
  },

  {
    name: "Kadahi Paneer",
    image: KadhaiPaneer,
    price: 500,
  },

  {
    name: "Palak Paneer",
    image: PalakPaneer,
    price: 450,
  },
  {
    name: "Chole Bhature",
    image: CholeBhature,
    price: 200,
  },

  {
    name: "Kadahi Paneer",
    image: KadhaiPaneer,
    price: 500,
  },

  {
    name: "Palak Paneer",
    image: PalakPaneer,
    price: 450,
  },
  {
    name: "Chole Bhature",
    image: CholeBhature,
    price: 200,
  },

  {
    name: "Kadahi Paneer",
    image: KadhaiPaneer,
    price: 500,
  },

  {
    name: "Palak Paneer",
    image: PalakPaneer,
    price: 450,
  },
];
